import styled from "styled-components";

export const ExtraContainer = styled.div`
    position: absolute;
    top: -20px;
    left: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 12px;
    z-index: 1;
`;

export const Icon = styled.img`
    width: 25px;
    height: 25px;
    object-fit: contain;
`;
